<div class="application-quest">
    <mat-toolbar color="primary" class="toolbar">
        <a mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
        </a>
        <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="gotoQuote()">
                <mat-icon>feed</mat-icon>
                <span>Quote</span>
            </a>
            <a mat-menu-item (click)="gotoPay()" *ngIf="paymentVisible">
                <mat-icon>credit_card</mat-icon>
                <span>Payment</span>
            </a>
            <a mat-menu-item (click)="gotoSign()" *ngIf="signVisible">
                <mat-icon>create</mat-icon>
                <span>Sign</span>
            </a>
        </mat-menu>
        <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo qLogo" />
        <div class="toolbar-inner-quest">High Limits Disability Insurance Application</div>
    </mat-toolbar>

    <div class="app-progress">
        <div class=app-progress-inner>Application Progress</div>
        <ngb-progressbar class="mb-3 progress-bar" [showValue]="true" type="primary" [value]="percent" />
    </div>

    <div class='app-questionnaire'>
        <div class="chat-quest">
            <div class="chat-box-quest">
                <img src="../assets/img/mgis/MgisLogo.png" alt="MGIS Logo" class="chat-image-quest" />
            </div>

        </div>
        <div class="prelim-questions" *ngIf="step!=='done'">
            <div class="text-bubble-quest">
                <div class="prelim-typing-effect">

                </div>
            </div>
            <div class="response" *ngIf="step==='ssn'">
                <div class="input-area-hc">
                    <mat-form-field class="chat-input-quest">
                        <mat-label>NPI</mat-label>
                        <input
                        matInput
                        name="npi"
                        [(ngModel)]="npi"
                        #npiModel="ngModel"
                        class="chat-input"
                        [required]="!isValidSSN(ssn)"
                        [errorStateMatcher]="npiMatcher"
                        maxlength="10"
                        (keydown)="preventNonNumeric($event)"
                        />
                        <mat-error *ngIf="npiModel.invalid">
                            Please enter your NPI
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="chat-input-quest">
                        <mat-label>SSN</mat-label>
                        <input
                        matInput
                        name="ssn"
                        [(ngModel)]="ssn"
                        #ssnModel="ngModel"
                        class="chat-input"
                        [required]="!isValidNPI(npi)"
                        [errorStateMatcher]="ssnMatcher"
                        maxlength="9"
                        (keydown)="preventNonNumeric($event)"
                        />
                        <mat-error *ngIf="ssnModel.invalid">
                            Please enter your SSN
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoQuote()" class="chat-button" mat-flat-button [disabled]="typing">Back</button>
                    <button (click)="this.healthQuestionsRouting(true)" class="chat-button" mat-flat-button [disabled]="typing ">Next</button>
                </div>
            </div>
            <div class="response" *ngIf="step==='height'">
                <div class="input-area-hc">
                    <mat-form-field class="chat-input-quest">
                        <mat-label>Height (Feet)</mat-label>
                        <input matInput [(ngModel)]="heightFeet" maxlength="1" class="chat-input" required
                            [errorStateMatcher]="matcher1" (input)="onHeightInput()" (keydown)="preventNonNumeric($event)"/>
                        <mat-error>Please enter a valid Height in Feet</mat-error>
                    </mat-form-field>
                    <mat-form-field class="chat-input-quest">
                        <mat-label>Height (Inches)</mat-label>
                        <input matInput [(ngModel)]="heightInches" maxlength="2" class="chat-input" required
                            [errorStateMatcher]="matcher2" (input)="onHeightInput()" (keydown)="preventNonNumeric($event)"/>
                        <mat-error>Please enter a valid height in Inches (0-11)</mat-error>
                    </mat-form-field>
                </div>
                <div class="input-area-hc">
                    <mat-form-field class="chat-input-quest">
                        <mat-label>Weight (lbs)</mat-label>
                        <input matInput [(ngModel)]="weight" maxlength="3" class="chat-input" required
                            [errorStateMatcher]="matcher3" (input)="onHeightInput()" (keydown)="preventNonNumeric($event)" />
                        <mat-error>Please enter a valid Weight</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-area">
                    <button (click)="gotoStep('ssn')" class="chat-button" mat-flat-button [disabled]="typing">Back</button>
                    <button (click)="gotoStep('done')" class="chat-button" mat-flat-button [disabled]="typing">Next</button>
                </div>
            </div>
        </div>
        <div class="main-chat-quest" *ngIf="step=='done'">
            <div class="text-bubble">
                <div class="typing-effect">
                </div>
            </div>
            @for ( question of questions; track question; let i = $index ) {
            <div class="response" *ngIf="currentQuestion == i">
                <div class="boolean-area">
                    <mat-radio-group class="custom-radio" aria-label="Select an option"
                    [(ngModel)]="question.AnswerBoolean" required *ngIf="question.AnswerType == 'Boolean'">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                    
                    <mat-error *ngIf="errorMessage && question.AnswerBoolean == undefined" style="color:red">Please
                        answer the
                        question</mat-error>
                </div>
                <div class="input-area input-area-questionnaire">
                    <mat-form-field class="full-textarea" *ngIf="question.AnswerType == 'Free Form'">
                        <textarea rows="5" cols="40" matInput [(ngModel)]="question.AnswerText" class="chat-input"
                        placeholder="Answer" [errorStateMatcher]="matcher" required (input)="onTextareaInput()"></textarea>
                        <mat-error>Please answer the question</mat-error>
                    </mat-form-field>
                </div>
                @if( question.ExplanationQuestions.length > 0 || question.AnswerType == 'None') {
                @for( subQuestion of question.ExplanationQuestions; track subQuestion; let j = $index ) {
                <div *ngIf="(question.AnswerBoolean == true || question.AnswerType == 'None') && subQuestion.AnswerType == 'Free Form'"
                    class="sub-question">
                    <div>
                        <div class="sub-question" *ngIf="subQuestion.AnswerType == 'Boolean'">
                            {{subQuestion.QuestionText}}
                        </div>
                        <div class="input-area input-area-questionnaire">
                            <mat-form-field class="full-textarea" *ngIf="subQuestion.AnswerType == 'Free Form'">
                                <div>
                                    {{subQuestion.QuestionText}} *
                                </div><br />
                                <textarea rows="5" cols="40" matInput [(ngModel)]="subQuestion.AnswerText"
                                class="chat-input" required [errorStateMatcher]="matcher" (input)="onTextareaInput()"></textarea>
                                <mat-error>Please answer the question</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                }
                }
                <div class="button-area">
                    <div class="button-area">
                        <button *ngIf="i == 0" (click)="this.healthQuestionsRouting(false)" class="chat-button" mat-flat-button 
                            [disabled]="typing">Back</button>
                        <button *ngIf="i != 0" (click)="gotoQuestion(i, -1)" class="chat-button" mat-flat-button 
                            [disabled]="typing">Back</button>
                        <button *ngIf="questions.length-1 != i" (click)="gotoQuestion(i, 1)" class="chat-button"
                            mat-flat-button [disabled]="typing">Next</button>
                        <button *ngIf="questions.length - 1 == i"
                                (click)="save()"
                                class="chat-button"
                                mat-flat-button
                                [disabled]="typing || isFinishDisabled()">
                        Finish
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>

</div>